var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4695 12.5C14.4695 12.2503 14.374 12.0373 14.1757 11.8463L8.44688 6.24237C8.29265 6.08079 8.087 6 7.85197 6C7.37457 6 6.99999 6.36723 6.99999 6.85198C6.99999 7.08701 7.09547 7.3 7.25705 7.46158L12.4203 12.5L7.25705 17.5384C7.09547 17.7073 6.99999 17.9203 6.99999 18.1554C6.99999 18.6328 7.37457 19 7.85197 19C8.087 19 8.29265 18.9192 8.44688 18.7576L14.1757 13.1537C14.374 12.9627 14.4621 12.7497 14.4695 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.8401ef65b9c924c5f171545c1f51d456.svg";
export { ForwardRef as ReactComponent };